import { heroChips, heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20theater%20stage%20with%20warm%20amber%20and%20crimson%20spotlight%20beams%20and%20drifting%20smoke%20above%20empty%20audience%20seats%2C%20cinematic%20high%20contrast%2C%20soft%20film%20grain%2C%20no%20people%2C%20luxurious%20editorial%20mood%2C%20high%20detail&width=1600&height=900&seq=hlcg-hero-bg-01&orientation=landscape"
          alt="黑料吃瓜爆料现场氛围图"
          title="黑料吃瓜 爆料现场"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
            <i className="ri-live-line text-accent-400"></i>
            爆料现场 · 每日更新 · 直击吃瓜第一现场
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
            围观网红爆料与绯闻大瓜
            <span className="mt-2 block text-accent-400 md:mt-3">直击吃瓜第一现场</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            每日汇总<span className="mx-0.5 font-medium text-white">明星黑料</span>、
            <span className="mx-0.5 font-medium text-white">网红黑料</span>与
            <span className="mx-0.5 font-medium text-white">绯闻实锤</span>。想快速围观今日大瓜、回顾往期热点，还是顺线索深挖事件真相，都能在实锤合集中找到完整脉络，一站式吃瓜不迷路。
          </p>

          <div className="mt-7 flex w-full max-w-xl items-center gap-2 rounded-lg border border-white/20 bg-white/10 p-1.5 backdrop-blur">
            <i className="ri-search-line ml-2 text-lg text-background-300"></i>
            <input
              type="text"
              placeholder="搜索明星 / 网红 / 事件关键词"
              className="min-w-0 flex-1 bg-transparent text-sm text-white placeholder:text-background-400 focus:outline-none"
            />
            <button
              type="button"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              搜索大瓜
            </button>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            {heroChips.map((chip) => (
              <a
                key={chip.label}
                href={chip.href}
                className="whitespace-nowrap rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-xs text-background-100 hover:bg-white/15"
              >
                {chip.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 border-t border-white/15 pt-6 md:grid-cols-4 md:gap-6">
          {heroStats.map((stat) => (
            <div key={stat.label} className="text-center md:text-left">
              <div className="font-heading text-2xl font-bold text-white md:text-3xl">{stat.value}</div>
              <div className="mt-1 text-xs text-background-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}